/**
 * @velyn-custom BEGIN — vely-mega-hover-banner.js (swap mega menu preview image on hover/focus; single img per panel)
 * Scope: [data-vely-mega-hover-wrap]
 */
(function () {
  const WRAP = "[data-vely-mega-hover-wrap]";
  const BANNER = "[data-mega-hover-banner]";
  const IMG = ".vely-mega-hover-banner__img";
  const TRIGGER = "a.vely-mega-hover-trigger[data-hover-preview-src]";

  let hoverTimer;

  function bindLeaveHandlers(root) {
    root.querySelectorAll(WRAP).forEach((wrap) => {
      if (wrap.dataset.velyMegaHoverLeaveBound) return;
      wrap.dataset.velyMegaHoverLeaveBound = "1";
      const img = wrap.querySelector(BANNER)?.querySelector(IMG);
      const defaultSrc = img?.dataset?.defaultSrc;
      if (!img || !defaultSrc) return;
      wrap.addEventListener("mouseleave", () => {
        if (img.src !== defaultSrc) img.src = defaultSrc;
      });
    });
  }

  function applyPreview(trigger) {
    const wrap = trigger.closest(WRAP);
    if (!wrap) return;
    if (window.innerWidth <= 1024 && wrap.closest("menu-drawer")) return;
    const img = wrap.querySelector(BANNER)?.querySelector(IMG);
    if (!img) return;
    const src = trigger.getAttribute("data-hover-preview-src");
    if (!src) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(() => {
      if (img.getAttribute("src") !== src) img.src = src;
      const alt = trigger.getAttribute("data-hover-preview-alt");
      if (alt != null) img.alt = alt;
    }, 48);
  }

  function init(root) {
    bindLeaveHandlers(root);
  }

  document.addEventListener(
    "mouseover",
    (e) => {
      const trigger = e.target.closest(TRIGGER);
      if (!trigger) return;
      applyPreview(trigger);
    },
    true,
  );

  document.addEventListener("focusin", (e) => {
    const trigger = e.target.closest(TRIGGER);
    if (!trigger) return;
    applyPreview(trigger);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(document));
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", (e) => {
    if (e.target) init(e.target);
  });
})();

/** @velyn-custom END — vely-mega-hover-banner.js */
